import React from 'react'
import "../styles/CardsEcosistemas.css";

export const EcosistemasCards = ({ecosistema}) => {
  return (
    <section className='cob__cards-in'>
        <div className="coberturas__cards-in">
            {/* VERSION DESKTOP */}
            <div className="cob__card d-none d-lg-flex" style={{maxHeight: "390px"}}>
                <div>
                    <div className='cob__card-img'>
                        <img className='cob__card-icoprincipal' src={ecosistema.img} alt="imagen cob" />
                        <div className='cob__card-ico_container ' >
                            <img className={`cob__card-ico`} src={ecosistema.ico} alt="imagen cob icono" />
                        </div>
                    </div>
                    <div className="cob__card-texto">
                        <div className="cob__card-superior">
                            <h4 className={`cob__card-title`} style={{height: "50px", marginTop: "2rem"}} dangerouslySetInnerHTML={{ __html: ecosistema.tituloEcosistema.replace('<br/>','<br class="d-block d-lg-none"/>') }}></h4>
                            <p className='cob__card-descripcion'>{ecosistema.descripcion}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* VERSION MOBILE */}
            <div className="cob__card d-flex d-lg-none" style={{ maxHeight: "470px"}}>
                <div>
                    <div className='cob__card-img'>
                        <img className='cob__card-icoprincipal' src={ecosistema.img} alt="imagen cob" />
                        <div className='cob__card-ico_container ' >
                            <img className={`cob__card-ico`} src={ecosistema.ico} alt="imagen cob icono" />
                        </div>
                    </div>
                    <div className="cob__card-texto">
                        <div className="cob__card-superior">
                            <h4 style={{ textAlign: 'center', marginTop: '0.5em', marginBottom: "2rem", height: "50px" }} className={`cob__card-title`} dangerouslySetInnerHTML={{ __html: ecosistema.tituloEcosistema.replace('<br/>','<br class="d-block d-lg-none"/>') }}></h4>
                            <p style={{ textAlign: 'center', lineHeight: '20px', fontSize: "18px", height: "150px" }} className='cob__card-descripcion cober__descripcion'>{ecosistema.descripcion}</p>  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
